export const SESSION_LOGIN_BEGIN = 'SESSION_LOGIN_BEGIN';
export const SESSION_LOGIN_SUCCESS = 'SESSION_LOGIN_SUCCESS';
export const SESSION_LOGIN_FAILURE = 'SESSION_LOGIN_FAILURE';
export const SESSION_LOGIN_DISMISS_ERROR = 'SESSION_LOGIN_DISMISS_ERROR';
export const SESSION_VALIDATE_BEGIN = 'SESSION_VALIDATE_BEGIN';
export const SESSION_VALIDATE_SUCCESS = 'SESSION_VALIDATE_SUCCESS';
export const SESSION_VALIDATE_FAILURE = 'SESSION_VALIDATE_FAILURE';
export const SESSION_VALIDATE_DISMISS_ERROR = 'SESSION_VALIDATE_DISMISS_ERROR';
export const SESSION_LOGOUT = 'SESSION_LOGOUT';
export const SESSION_COGNITO_LOGIN_BEGIN = 'SESSION_COGNITO_LOGIN_BEGIN';
export const SESSION_COGNITO_LOGIN_SUCCESS = 'SESSION_COGNITO_LOGIN_SUCCESS';
export const SESSION_COGNITO_LOGIN_FAILURE = 'SESSION_COGNITO_LOGIN_FAILURE';
export const SESSION_COGNITO_LOGIN_DISMISS_ERROR = 'SESSION_COGNITO_LOGIN_DISMISS_ERROR';
export const SESSION_SET_SESSION = 'SESSION_SET_SESSION';



// WEBPACK FOOTER //
// ./src/features/session/redux/constants.js